import { createSlice } from '@reduxjs/toolkit';
import DataExportsAPI from '~/api/data-exports-api';
import DataExportStatusConstants from '~/constants/data-export-status-constants';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import { addDataExportCasesToBuilder } from '../../reducer-utils';
import {
  defaultState,
  prependExportToHistory,
} from '../../data/DataExportCardState';

export const exportRoboticMowerUsageData = createCaughtAsyncThunk<
  any,
  { from: string; to: string }
>('exportRoboticMowerUsageData', async (args) => {
  return DataExportsAPI.exportRoboticMowerUsage(args.from, args.to);
});

export const getRoboticMowerUsageDataExportStatus = createCaughtAsyncThunk<
  any,
  string
>('getRoboticMowerUsageDataExportStatus', async (id, thunkAPI) => {
  const response = await DataExportsAPI.getExportStatus(id);

  if (response.status === DataExportStatusConstants.CREATED) {
    //Prepend to list of downloads
    thunkAPI.dispatch(prependToHistory(response));
  }
  return response;
});

const slice = createSlice({
  name: 'data-exports-robotic-mower-usage',
  initialState: defaultState,
  reducers: {
    prependToHistory: (state, action) => {
      state.exportHistory = prependExportToHistory(
        state.exportHistory,
        action.payload
      );
    },
  },
  extraReducers: (builder) => {
    addDataExportCasesToBuilder(
      builder,
      'roboticMowerUsage',
      exportRoboticMowerUsageData,
      getRoboticMowerUsageDataExportStatus
    );
  },
});

export const { prependToHistory } = slice.actions;
export default slice.reducer;
